<script setup lang="ts">
import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

defineProps<{
  question: Question;
}>();
</script>

<template>
  <section class="rounded-3xl bg-slate-950 p-6 text-white shadow-sm">
    <p class="text-[11px] font-semibold uppercase tracking-[0.18em] text-sky-200">Question {{ question.number }}</p>
    <h1 class="mt-2 text-2xl font-bold tracking-tight">{{ question.question }}</h1>
    <div class="mt-4 flex items-center gap-2 text-xs">
      <span class="rounded-full bg-white/10 px-3 py-1 font-medium uppercase tracking-wide">{{ question.type }}</span>
      <span class="rounded-full bg-white/10 px-3 py-1 font-medium uppercase tracking-wide">{{ question.difficulty }}</span>
      <span class="rounded-full bg-white/10 px-3 py-1 font-medium">{{ question.topic }}</span>
    </div>
  </section>
</template>
